module.exports = __webpack_public_path__ + "img/person-icon.224b65c.png";